export default __webpack_public_path__ + "sounds/gasp.mp3";